<template>
    <div class="language-switcher">
        <!-- <span>{{ t('common.language') }}</span> -->
        <t-button variant="text" :theme="appSettingStore.currentLocale === 'zh-CN' ? 'primary' : ''" size="small"
            @click="onLocaleChange('zh-CN')">
            {{ t('common.langZhCN') }}
        </t-button>
        |
        <t-button variant="text" :theme="appSettingStore.currentLocale === 'en-US' ? 'primary' : ''" size="small"
            @click="onLocaleChange('en-US')">
            {{ t('common.langEnUS') }}
        </t-button>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { setAppLocale } from '../i18n';
import { useAppSettingStore } from '../store/index_SignIn';

const appSettingStore = useAppSettingStore();
const { t } = useI18n();

const onLocaleChange = (localeValue: string) => {
    appSettingStore.setCurrentLocale(localeValue);
    setAppLocale(localeValue);
};
</script>

<style lang="less" scoped>
.language-switcher {
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
